export class UpdateCustomerNotes {
    public orderID: string;
    public notes: string;
}
